import React from 'react';
import { Link } from 'react-router-dom';

const asideItem = {
  title: '회사소개',
  contents: [
    { url: 'about', text: '회사소개' },
    { url: 'policy', text: '이용약관' },
    { url: 'privacy', text: '개인정보취급방침' },
  ],
};

export function AsideAbout() {
  return (
    <aside>
      <h3>{asideItem.title}</h3>
      {asideItem.contents.map((element) => (
        <Link to={element.url} key={Math.random()}>
          {element.text}
        </Link>
      ))}
    </aside>
  );
}
